// extracted by mini-css-extract-plugin
module.exports = {"loadingIndicatorContainer":"LoadingIndicator_loadingIndicatorContainer__3l55b","spinner":"LoadingIndicator_spinner__7f7qQ"};